const generateReduxModuleDependency = ({ id, reducer, actionsDefinition, selectorDefinitions, eventReducers, actionReducers, }) => {
    return {
        id,
        type: 'redux-module',
        factory: (...dependencies) => ({
            reducer,
            eventReducers,
            actionReducers,
            selectors: selectorDefinitions && dependencies.shift(),
            actions: dependencies.shift(),
        }),
        dependencies: [
            ...(selectorDefinitions ? [`${id}.selectors`] : []),
            ...(actionsDefinition ? [`${id}.actions`] : []),
        ],
    };
};
export default generateReduxModuleDependency;
